import Route from '@ember/routing/route';
import type ZoneModel from 'garaje/models/zone';

export default class PropertyDevicesPrintersConnectionsNewRoute extends Route {
  model(): ZoneModel {
    return <ZoneModel>this.modelFor('property');
  }
}
